import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import SesService from 'services/SesService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	pagination: {
		content: [],
		totalElements: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 10,
	},
}

export const getAllPaginated = createAsyncThunk('ses/allPaginated', async (params, { rejectWithValue }) => {
	try {
		const response = await SesService.paginated(params)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar emails')
	}
})

export const getAll = createAsyncThunk('ses/all',async () => {
    const response = await SesService.all()
    return response;
})

export const sesSlice = createSlice({
	name: 'ses',
	initialState,
	reducers: {
		
	},
    extraReducers: (builder) => {
		builder
			.addCase(getAllPaginated.pending, (state) => {
				state.loading = true
			})
			.addCase(getAllPaginated.fulfilled, (state, action) => {
				state.loading = false
				state.pagination = {
					content: action.payload.content,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages,
					currentPage: action.payload.number,
					pageSize: action.payload.size,
				}
			})
			.addCase(getAllPaginated.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getAll.pending, (state) => {
				state.loading = true
			})
			.addCase(getAll.fulfilled, (state, action) => {
				state.loading = false
				// state.redirect = '/'
				state.ses = action.payload
			})
			.addCase(getAll.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
	},
})

export const {
	showLoading,
} = sesSlice.actions

export default sesSlice.reducer